module.exports = __webpack_public_path__ + "img/google-logo.89a7def6.svg";